module.exports = __webpack_public_path__ + "img/icon-report.bd45fb40.svg";